import { Layers } from "lucide-react";
import type { ProductOption } from "@/services/productOptions";

/**
 * OPT-B2b · 「资源与售价」页签顶部的选项切换（样稿 ④）：产品有 ≥ 2 个选项才显示；只有 1 个时整行不出现，页面不变。
 * 只列可售的选项（停售的选项没有对外价）；默认选项在前，标「默认」。
 */
export function OptionSwitch({ options, value, onChange, note }: { options: ProductOption[]; value: string | null; onChange: (optionId: string) => void; note?: string }) {
  const shown = options.filter((o) => o.status === "active" || o.id === value);
  if (options.length < 2) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3" data-testid="option-switch">
      <span className="inline-flex items-center gap-1.5 text-[13px] font-medium text-slate-600"><Layers size={14} className="text-blue-600" />查看选项：</span>
      <span role="radiogroup" aria-label="选项" className="inline-flex flex-wrap overflow-hidden rounded-lg border border-slate-300">
        {shown.map((o, i) => (
          <button key={o.id} type="button" role="radio" aria-checked={value === o.id} data-testid={`option-switch-${o.letter}`} onClick={() => onChange(o.id)}
            className={`px-3 py-1.5 text-[13px] ${i > 0 ? "border-l border-slate-300" : ""} ${value === o.id ? "bg-blue-50 font-semibold text-blue-700" : "bg-white text-slate-600 hover:bg-slate-50"}`}>
            {o.name_cn}{o.is_default ? "（默认）" : ""}
          </button>
        ))}
      </span>
      {note && <span className="w-full text-[12px] text-slate-400">{note}</span>}
    </div>
  );
}
